module.exports = __webpack_public_path__ + "static/media/COS_ISISPHARMA.fdc35074.png";